import {
    apiRequest,
    skillcertificationCreate,
    masterRegion,
    admindiklatListPegawai
} from "../../../../../../services/adapters/kepegawaian/skillcertificationService"

class CreateRepository {

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", skillcertificationCreate, {
            body: query
        }, true)
    }

    fetchPegawai = async (query) => {
        return await apiRequest("get", admindiklatListPegawai, {
            body: query
        }, true)
    }
}

export default CreateRepository